import { useCallback } from 'react';

import { useHttp } from '@/shared/api/provider';

import { usePhones } from '../store/phones';

import type { IPhoneData } from '@/entities/common/types/phones';

import type { PhoneData } from '../types';

export const usePhoneData = (doctorId?: number, medcenterId?: number | null) => {
  const { setLoading, setPhones } = usePhones();

  const repositories = useHttp();

  const fetchPhoneData = useCallback(async () => {
    setPhones([]);

    if (!doctorId && !medcenterId) {
      return;
    }

    setLoading(true);

    try {
      const phoneData: IPhoneData = await repositories.doctor.getPhonesDoctor(medcenterId ?? undefined, doctorId);
      let phones = [];

      if (phoneData.data.medcenters?.length) {
        const medcenter = phoneData.data.medcenters.find(mc => mc.id === medcenterId);
        if (medcenter?.phones?.length) {
          phones.push(...medcenter.phones.map(phone => ({ ...phone, type: 'medcenter' })));
        }
      }

      if (doctorId && phoneData.data.doctors?.length) {
        const doctor = phoneData.data.doctors[0];
        if (doctor.phones?.length) {
          phones.push(...doctor.phones.map(phone => ({ ...phone, type: 'doctor' })));
        }
      }

      phones = phones.sort((a, b) => b.answerRatePercentage - a.answerRatePercentage);
      setPhones(phones as PhoneData[]);
    } catch (error) {
      console.error('Error fetching phone data:', error);
    } finally {
      setLoading(false);
    }
  }, [doctorId, medcenterId, repositories]);

  return { fetchPhoneData };
};
